import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import {
  getRetryLabelDisabledReason,
  shouldDisableRetryLabel,
  shouldHideRetryLabel,
} from '@/returns/pages/TransactionDetailPage/helpers'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'
import { transformRequestGenerateReturnLabel } from './transformers'

const useGenerateLabel = ({
  returnId,
  includesRejectedItems,
  allowsGenerateLabelReason,
  pickupScheduled,
  isShippingActionInProgress,
  timeZone,
  setToastInfo,
}) => {
  const { t, i18n } = useTranslation()
  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)
  const { fetchData: generateLabel, loading: generatingLabel } = useFetch(returnsServices.generateReturnLabel, {
    doInitialRequest: false,
    transformRequest: transformRequestGenerateReturnLabel,
  })

  const onGenerateLabel = async ({ includeRejectedItems, discardLabels }) => {
    const response = await generateLabel({ resourceId: returnId, includeRejectedItems, discardLabels })

    setPendingWebsocketAction(pendingWebsocketActionTypes.generateLabel, response)
  }

  const onRetryLabel = async () => {
    try {
      await onGenerateLabel({ includeRejectedItems: includesRejectedItems })
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    onGenerateLabel,
    onRetryLabel,
    generatingLabel,
    isRetryLabelHidden: shouldHideRetryLabel(allowsGenerateLabelReason),
    isRetryLabelDisabled: shouldDisableRetryLabel({
      allowsGenerateLabelReason,
      isShippingActionInProgress: generatingLabel || isShippingActionInProgress,
    }),
    retryLabelDisabledReason: getRetryLabelDisabledReason({
      allowsGenerateLabelReason,
      pickupScheduled,
      t,
      language: i18n.language,
      timeZone,
    }),
  }
}

export default useGenerateLabel
